import {
    Box,
    Checkbox as MuiCheckbox,
    CheckboxProps,
    useTheme,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { CheckBoxIcon } from '../../eid-icons'
import { CheckedBoxIcon } from '../../eid-icons'
import React, { forwardRef } from 'react'

const StyledCheckbox = styled(MuiCheckbox)({
    justifyContent: 'start',
    maxWidth: 'fit-content',
    '&:hover': {
        backgroundColor: 'transparent !important',
    },
})

const Checkbox = forwardRef<any, CheckboxProps>((props, ref) => {
    const theme = useTheme()

    return (
        <StyledCheckbox
            edge="start"
            color="primary"
            icon={
                <Box display="flex" alignItems="center">
                    <CheckBoxIcon />
                </Box>
            }
            checkedIcon={
                <Box display="flex" alignItems="center">
                    <CheckedBoxIcon color={theme.palette.primary.main} />
                </Box>
            }
            disableRipple
            disableFocusRipple
            ref={ref}
            {...props}
        />
    )
})

export default Checkbox
